import { CategoriaEnum } from '@acme/auth'
import { PreLoading } from 'global/components/LoadingCustumer'
import { hasPathPermission } from 'hooks/useBackendMenu'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useStore } from 'store'
import { NotFound } from 'templates/NotFound'
import { useAuth } from '../hooks'

export function PrivateRoutes() {
    const user = useAuth()
    const navigate = useNavigate()
    const cliente = useStore(state => state.customer)

    const location = useLocation()

    const [isPaginaPlanos, isPaginaSelecionar, isPaginaAtendimento] = [
        location.pathname.includes('planos'),
        location.pathname === '/selecionar-funcionario',
        location.pathname === '/ajuda/atendimento-online',
    ]

    const novo =
        cliente?.status === 'withoutSubscriptionOrCharge' &&
        user.decoded.categoria === CategoriaEnum.Cliente
    const diasAvaliacao = Number(user?.decoded?.diasAvaliacao ?? null)
    const avaliante =
        user.decoded?.categoria === CategoriaEnum.Avaliacao ||
        (user.decoded?.categoria === CategoriaEnum.Cliente && diasAvaliacao > 0)
    const naoVerificar = [
        CategoriaEnum.Administrador,
        CategoriaEnum.Suporte,
        CategoriaEnum.Funcionario,
        CategoriaEnum.Representante,
    ].includes(user.decoded?.categoria)

    if (!user.auth) {
        return navigate('/') as any
    } else if (isPaginaAtendimento) {
        return <Outlet />
    } else if (
        user.auth &&
        user.decoded?.categoria === CategoriaEnum.Funcionario &&
        !user.funcionarioSelecionado &&
        !isPaginaSelecionar
    ) {
        return navigate('/selecionar-funcionario') as any
    } else if (!cliente && !naoVerificar) {
        return <PreLoading />
    } else if (!isPaginaPlanos && novo && !avaliante) {
        return navigate('/planos') as any
    } else if (
        !hasPathPermission('read', location.pathname) &&
        !isPaginaPlanos
    ) {
        return <NotFound />
    }

    return <Outlet />
}
